var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0013 1.16602C3.7813 1.16602 1.16797 3.77935 1.16797 6.99935C1.16797 10.2193 3.7813 12.8327 7.0013 12.8327C10.2213 12.8327 12.8346 10.2193 12.8346 6.99935C12.8346 3.77935 10.2213 1.16602 7.0013 1.16602ZM6.41797 4.08268V5.24935H7.58464V4.08268H6.41797ZM6.41797 6.41602V9.91602H7.58464V6.41602H6.41797ZM2.33464 6.99935C2.33464 9.57185 4.4288 11.666 7.0013 11.666C9.5738 11.666 11.668 9.57185 11.668 6.99935C11.668 4.42685 9.5738 2.33268 7.0013 2.33268C4.4288 2.33268 2.33464 4.42685 2.33464 6.99935Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info_icon.def69e60b0de379d5f89eb38a80a3ec4.svg";